import styled from "styled-components";

export const Container = styled.div`
  width: 80px;
  margin: 0 auto;
`;
